import Typography from 'components/generics/texts/Typography';
import useRecurringActions from 'hooks/requests/account/useRecurringActions';
import RecurringActionRow from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/AutoDepositSection/components/RecurringDepositsList/components/RecurringActionRow';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const RecurringDepositsList = () => {
  const { recurringActions, loading } = useRecurringActions();
  const recurringActionsFiltered = recurringActions?.filter(
    (action) => action.performing
  );

  if (loading) {
    return (
      <Skeleton
        width={140}
        height={30}
      />
    );
  }

  if (recurringActionsFiltered?.length === 0) {
    return <Typography>No recurring actions</Typography>;
  }

  return (
    <div>
      {recurringActionsFiltered?.map((action, index) => {
        return (
          <RecurringActionRow
            recurringAction={action}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default RecurringDepositsList;
